<div class="reports-holder">
  <div class="reports-center">

    <div class="header">

      <!-- <app-reports-select id="category-select" [data]="this.categories" [textField]="'category'" [valueField]="'categoryCode'"></app-reports-select> -->
      <div class="category-select">
        <kendo-floatinglabel text="Category">
          <kendo-dropdownlist class="categoryDrop" [data]="this.categories" [value]="value"
                              [loading]="loadingService.loaderActive===true" textField="category" valueField="categoryCode"
                              (valueChange)="valueChangeInternal($event)">

          </kendo-dropdownlist>
        </kendo-floatinglabel>
      </div>

      <div class="report-select">
        <kendo-floatinglabel text="Report">
          <kendo-dropdownlist class="reportDrop" [data]="this.filteredReports" [value]="filteredReportsValue"
                              [loading]="" textField="name" valueField="id" (valueChange)="reportChange($event)">
          </kendo-dropdownlist>
        </kendo-floatinglabel>
      </div>
    </div>
    <form [formGroup]="mainForm" class="form-flow">
      <div class="body"></div>

      <div *ngFor="let param of parameters" class="form-row">
        <app-dynamic-form [param]="param" [form]="mainForm"></app-dynamic-form>
      </div>

      <div>
        <app-reports-extract *ngIf="showExtract" [hoId]="this.userService.selectedHomeOffice.hoId"
                             [(currentSavedFields)]="currentSavedFields"
                             [reportId]="this.currentReport.id"></app-reports-extract>
      </div>


    </form>
    <kendo-label text="Export Type" *ngIf="reportTypeHidden">
      <kendo-dropdownlist *ngIf="reportTypeHidden"
                          [data]="listItems"
                          [value]="selectedOption"
                          (valueChange)="typeChange($event)">
      </kendo-dropdownlist>
    </kendo-label>
    <div fxLayoutAlign="end center">
      <app-mcl-button [disabled]="loadingService.loaderActive===true || !mainForm.valid"
                  (click)="Submit()"
                  [loading]="loadingService.loaderActive===true"
                  inprogressMessage="Loading Report..."
                  text="Load Report"
                  primary="true"
                  style="padding-top: 5px;">
      </app-mcl-button>
    </div>


  </div>
</div>
<div kendoDialogContainer></div>
